import { createMasker } from '@creditas-ui/utilities';

const formatPhone = (value: string): string => {
  return createMasker('00 0 0000-0000').mask(value);
};

export { formatPhone };
